import { render } from "./TextShare.vue?vue&type=template&id=3ae49ce8&scoped=true"
import script from "./TextShare.vue?vue&type=script&lang=js"
export * from "./TextShare.vue?vue&type=script&lang=js"

import "./TextShare.vue?vue&type=style&index=0&id=3ae49ce8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae49ce8"]])

export default __exports__